import { render, staticRenderFns } from "./BookmarksTable.vue?vue&type=template&id=2a2eadea&scoped=true&"
import script from "./BookmarksTable.vue?vue&type=script&lang=js&"
export * from "./BookmarksTable.vue?vue&type=script&lang=js&"
import style0 from "./BookmarksTable.vue?vue&type=style&index=0&id=2a2eadea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2eadea",
  null
  
)

export default component.exports